import { Typography } from '@mui/material'
import { DataTestId } from '@project-minerva/typings'
import { ReactNode } from 'react'

export const HeaderTitle = (props: { children: ReactNode } & DataTestId) => (
  <Typography data-testid={props['data-testid']} sx={{ fontWeight: 600, fontSize: '26px' }} component="h2" variant="h5">
    {props.children}
  </Typography>
)
